import axiosInstance from "../api";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";
import { GET_CALENDER } from "../constants";

export const getCalender = (start_date, end_date, id) => async (dispatch) => {
  console.log('API CALLED FOR CALENDAR', start_date, end_date, id);

  try {
    const response = await axiosInstance.get(
      `calendar?type=1&start_date=${start_date}&end_date=${end_date}&id=${id}`
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_CALENDER,
        calenderdetails: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const addCalender = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.post("calendar", data);
    if (response?.data?.status) {
      // dispatch(getCalender(data?.start_date, data?.end_date));
      urtoast(response?.data?.response?.message, 1);
      window.location.reload()
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const updateCalender = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.put("calendar/update", data);
    if (response?.data?.status) {
      // dispatch(getCalender(data?.start_date, data?.end_date));
      urtoast(response?.data?.response?.message, 1);
      window.location.reload()
      return;
    }
    console.error();
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    console.error();
    //urtoast(err.message, 2);
  }
};

export const deleteCalender = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`calendar?type=1&id=${id}`);
    if (response?.data?.status) {
      dispatch(getCalender());
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};


export const deleteCalenderLeaves = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.delete(`calendar/delete?type=1&id=${id}`);
    if (response?.data?.status) {
      urtoast(response?.data?.response?.message, 1);
      window.location.reload()
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};
